import { useEffect, useRef, useState } from "react";
import { API_URL, getHeaders } from "../config";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { Worker } from '@react-pdf-viewer/core';

import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import "../assets/styles/scrollbar.css";

/**
 * `onPage(page, pageCount)` is the completion-evidence hook: it fires with the
 * 1-based page actually rendered, so the server can tell "read the deck" apart
 * from "opened and closed it". Optional — omit it and the viewer is unchanged.
 */
export const PDFViewer = ({ pdf, width, height, onPage }) => {

  const [url, setUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const pageCountRef = useRef(0);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };


  useEffect(() => {
    if(url) {
      console.log("url>>>>>>>>", url);
    }
  }, [url]);

    // useEffect(() => {
    //     if (pdf) {
    //       console.log("ppt---", pdf);
    //       const fetchSignedUrl = async () => {
    //         setIsLoading(true);
    //         try {
    //           const response = await axios.get(
    //             `${API_URL}/api/PPT/signed-url?key=${pdf}`,
    //             { headers: getHeaders().headers }
    //           );
    //           const signedUrl = response.data?.url;
    //           console.log("Signed URL fetched:", signedUrl);
    //           setUrl(signedUrl); // Set the signed URL
    //         } catch (e) {
    //           console.error("Error fetching signed URL", e);
    //           setIsLoading(false);
    //           const { status } = e?.response;
    //         if (!status) return;
    //         if (status === 401 || status === 403) {
    //           handleLogout();
    //         }
    //         }
    //       };
    
    //       fetchSignedUrl();
    //     }
    //   }, [pdf]);
    

    return (
        <>
           {
            pdf &&
            // No border or radius of its own — the section stage already
            // provides the surface this sits in.
            <div className="ds-scroll" style={{ height: height || '78vh', width: width || '100%', overflow: 'auto', padding: 'var(--s-4)' }}>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <Viewer
                  fileUrl={`${API_URL}/api/assets/PDF/${pdf}`}
                  onDocumentLoad={(e) => {
                    pageCountRef.current = e.doc?.numPages || 0;
                    // Page 1 is on screen the moment the document renders.
                    if (onPage) onPage(1, pageCountRef.current);
                  }}
                  onPageChange={(e) => {
                    // The library reports a 0-based index; evidence is 1-based.
                    if (onPage) onPage((e.currentPage || 0) + 1, pageCountRef.current);
                  }}
                />
              </Worker>
            </div>
           }

        </>
    )
}